module.exports = __webpack_public_path__ + "img/card3.1dc121d8.png";